import PropTypes from 'prop-types';
import React from 'react';
import PhotosView from './PhotosView';
import PhotosForm from './PhotosForm';

class Photos extends React.Component {
  constructor() {
    super();
    this.state = {
      isEditing: false,
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  handleEdit() {
    this.setState({ isEditing: true });
  }
  handleClose() {
    this.setState({ isEditing: false });
  }
  render() {
    if (this.state.isEditing || this.props.isAddHotel) {
      return (
        <PhotosForm
          {...this.props}
          handleClose={this.handleClose}
        />);
    }
    return (
      <PhotosView {...this.props} handleEdit={this.handleEdit} />
    );
  }
}
Photos.propTypes = {
  hotel: PropTypes.object.isRequired,
  addHotelPhoto: PropTypes.func.isRequired,
  editHotelPhoto: PropTypes.func.isRequired,
  removeHotelPhoto: PropTypes.func.isRequired,
  sortHotelPhotos: PropTypes.func.isRequired,
};

export default Photos;



// WEBPACK FOOTER //
// src/routes/hotels/components/Photos.js